import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import { useSalesBotStore } from '@/store/modules/salesBot'
import SkeletonBox from '@/components/SkeletonBox.vue'
import SalesBotAmenityOptionCard from '@/components/SalesBotAmenityOptionCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotAmenities',
  emits: ['form:validate'],
  setup(__props, { emit }) {

const salesBotStore = useSalesBotStore()
const { toggleAmenity } = salesBotStore

const amenitiesKeys = computed(() => salesBotStore.amenitiesKeys)
const amenityOptions = computed(() => salesBotStore.amenityOptions)
const amenityOptionsLoading = computed(() => salesBotStore.amenityOptionsLoading)
const amenityOptionsEmpty = computed(() => {
  return amenityOptions.value.length === 0
})

const isAmenitySelected = (amenityKey: string): boolean => {
  return amenitiesKeys.value.includes(amenityKey)
}



const validate = (): boolean => {
  // There is currently no way to select invalid amenities
  const isValid = true

  emit('form:validate', isValid)
  return isValid
}


return { __sfc: true,salesBotStore, toggleAmenity, amenitiesKeys, amenityOptions, amenityOptionsLoading, amenityOptionsEmpty, isAmenitySelected, emit, validate, SkeletonBox, SalesBotAmenityOptionCard }
}

})